import React, { forwardRef } from 'react';
import { Checkbox } from '../ui/checkbox';
import { Box } from '@chakra-ui/react';

export const CustomCheckbox = forwardRef(({ children, ...props }, ref) => {
    return (
        <Box 
            p={3} 
            borderWidth="1px" 
            borderRadius="md" 
            borderColor="gray.200"
            _hover={{ borderColor: "blue.300", bg: "gray.50" }}
            transition="all 0.2s"
            cursor="pointer"
        >
            <Checkbox ref={ref} {...props} gap={3}>
                {children}
            </Checkbox>
        </Box>
    );
});
